import Vue from "vue"
import router from "./router"
import store from "./store"
import VueMeta from "vue-meta"
import Element from "element-ui"
import Print from 'vue-print-nb'
import {
  Message
} from 'element-ui'

let messageInstance = null;
const overrideMessage = (options) => {
    if(messageInstance) {
        messageInstance.close()
    }
    messageInstance = Message(options)
}
['error','success','info','warning'].forEach(type => {
    overrideMessage[type] = options => {
        if(typeof options === 'string') {
            options = {
                message:options
            }
        }
        options.type = type
        return overrideMessage(options)
    }
})
Vue.use(Element)
Vue.use(Print);
Vue.prototype.$message = overrideMessage;

import scroll from 'vue-seamless-scroll'

import "element-ui/lib/theme-chalk/index.css"
import "./assets/styles/main.scss"
import "./assets/styles/element-variables.scss"

import VideoPlayer from "vue-video-player"
import "video.js/dist/video-js.css"

import App from "./App.vue"

import Util from "./utils/util"
import Lang from "./utils/lang.js"
import Config from "./utils/config.js"
import {
    consumeWarehouseHostFromUrl,
    getWarehouseHost,
    WAREHOUSE_HOST_KEY
} from "./utils/warehouseStorage"

const MERCHANT_SESSION_STORAGE_KEYS = ["systemConfig", "member", "agentInfo", "joinCartStatus"]
const MERCHANT_LOCAL_STORAGE_KEYS = ["kefu_tourists_token"]

function clearStorageKeys(storage, keys) {
    try {
        keys.forEach(key => storage.removeItem(key))
    } catch (error) {
        // 浏览器禁用存储时仍继续使用本次内存中的新商户上下文。
    }
}

const defaultWarehouseHost = Config.defaultWarehouseHost || Config.baseUrl
const merchantContext = consumeWarehouseHostFromUrl(defaultWarehouseHost)
const activeWarehouseHost = merchantContext.applied
    ? merchantContext.warehouseHost
    : getWarehouseHost(defaultWarehouseHost)

if (activeWarehouseHost) {
    const merchantDomain = `${activeWarehouseHost}/`
    // API 仍请求统一 baseUrl；商户域名用于请求头、相对图片和前端链接。
    Config.warehouseHost = activeWarehouseHost
    Config.warehouse_host = activeWarehouseHost
    Config.imgDomain = merchantDomain
    Config.webDomain = merchantDomain
}

if (merchantContext.applied && merchantContext.changed) {
    // 不同商户的 token、站点配置和业务缓存不能交叉复用。
    store.dispatch("member/remove_token")
    store.commit("site/RESET_MERCHANT_CONTEXT")
    store.commit("cart/SET_CART_COUNT", 0)
    store.commit("order/RESET_MERCHANT_CONTEXT")

    clearStorageKeys(sessionStorage, MERCHANT_SESSION_STORAGE_KEYS)
    clearStorageKeys(localStorage, MERCHANT_LOCAL_STORAGE_KEYS)
}

Vue.prototype.$store = store //挂在vue
Vue.config.productionTip = false

// 常用工具函数
Vue.prototype.$util = Util
Vue.prototype.$img = Util.img
Vue.prototype.$timeStampTurnTime = Util.timeStampTurnTime
Vue.prototype.$copy = Util.copy
window.util = Util
window.img = Util.img
window.timeStampTurnTime = Util.timeStampTurnTime
window.copy = Util.copy

// 语言包
Vue.prototype.$langConfig = Lang //语言包对象
Vue.prototype.$lang = Lang.lang //解析语言包
window.langConfig = Lang
window.lang = Lang.lang

Vue.prototype.$config = Config

window.addEventListener("storage", event => {
    if (event.key !== WAREHOUSE_HOST_KEY || event.oldValue === event.newValue) return

    // 其它标签切换商家后清除本标签旧的商户配置，再刷新上下文。
    clearStorageKeys(sessionStorage, [WAREHOUSE_HOST_KEY, ...MERCHANT_SESSION_STORAGE_KEYS])
    window.location.reload()
})

Vue.use(VideoPlayer)
Vue.use(VueMeta)
Vue.use(scroll)

window.vue = new Vue({
    router,
    store,
    metaInfo() {
        return {
            // title: store.getters.siteInfo.site_name || "",
            meta: [
                // { name: "title", content: store.getters.siteInfo.site_name || "" },
                { name: "desc", content: store.getters.siteInfo.seo_description || "" },
                { name: "keywords", content: store.getters.siteInfo.seo_keywords || "" }
            ]
        }
    },
    render: h => h(App)
}).$mount("#app")
